import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import logoIscert from '../assets/logo-iscert.svg';
import { getFile } from '../utils/indexedDB';
import {useAuth} from "../utils/authContext";
import {fetchCertificates, getUserInfo} from "../services/userInfoService";

export const Consent = ({ fileName: propFileName }) => {
const { t } = useTranslation();
  const [isDocumentRead, setIsDocumentRead] = useState(false);
  const [documentUrl, setDocumentUrl] = useState('');
  const [fileName, setFileName] = useState(propFileName || sessionStorage.getItem('fileName'));
  const navigate = useNavigate();
  const { token } = useAuth();
  const [userName, setUserName] = useState('');

  useEffect(() => {
    if (fileName) {
      getFile(fileName).then(storedDocument => {
        if (storedDocument) {
          setDocumentUrl('data:application/pdf;base64,' + storedDocument);
        }
      });
    }
    const fetchUserInfo = async () => {
      try {
        const userInfo = await getUserInfo(token);
        setUserName(userInfo.name);
      } catch (error) {
        console.error('Error fetching user info:', error);
      }
    };


    fetchUserInfo();
  }, [fileName, token]);

  const handleCheckboxChange = () => {
    setIsDocumentRead(!isDocumentRead);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (isDocumentRead) {
          navigate('/pin');
    }
  };

  const handleCancel = () => {
    navigate('/signer/signDocument');
  };

  return (
    <section id="cripto">
      <div className="brand-logo">
        <img className="img-fluid" src={logoIscert} alt="Logotipo iSCert" />
      </div>
      <form className="form-signin" onSubmit={handleSubmit}>
        <h2 className="txt-small text-left">{t('consent.title')}</h2>
        <p className="txt-sub text-left">
          <span className="upper">{userName}, </span>{t('consent.detail-1')}
        </p>
        <div className="doc-area">
          {documentUrl && (
            <a 
              className="document" 
              href={documentUrl} 
              download={fileName}
            >
              {fileName}
              <i className="icon-download"> </i>
            </a>
          )}
        </div>
        <div className="form-group form-check abc-checkbox">
          <input
            className="form-check-input"
            id="checkbox1"
            type="checkbox"
            checked={isDocumentRead}
            onChange={handleCheckboxChange}
          />
          <label className="form-check-label" htmlFor="checkbox1">{t('consent.consent-label')}</label>
        </div>
        <div className="form-group mb-0">
          <button 
            className="btn btn-login btn-block" 
            type="submit" 
            disabled={!isDocumentRead}
          >
            {t('consent.confirm-button')}
          </button>
          <a 
            className="btn link-cancel" 
            type="button" 
            onClick={handleCancel}
          >
            {t('consent.cancel-button')}
          </a>
        </div>
      </form>
    </section>
  );
};
